var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "background" },
    [
      _c(
        "v-col",
        { attrs: { cols: "9" } },
        [
          _vm.hasData
            ? _c(
                "custom-chart-renderer",
                {
                  attrs: { title: _vm.title },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "refresh",
                        fn: function() {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "", color: "green" },
                                on: { click: _vm.resetChart }
                              },
                              [_c("v-icon", [_vm._v("mdi-cached")])],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    4190047584
                  )
                },
                [
                  _vm._v(" "),
                  _c("scatter-chart", {
                    attrs: {
                      chartData: _vm.chartDataMonthSig,
                      options: _vm.optionsSig,
                      reset: _vm.resetZ,
                      autoRerender: false,
                      displayed: _vm.displayed
                    },
                    on: {
                      unzoomed: function($event) {
                        _vm.resetZ = false
                      }
                    }
                  })
                ],
                1
              )
            : _c("span", { staticClass: "d-flex justify-center font-italic" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.generateMessage("properties_360.readings.no_data")
                    ) +
                    "\n    "
                )
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "3" } },
        [
          _c(
            "v-row",
            [
              _vm.market === "MC" || _vm.market === "MCI"
                ? _c(
                    "v-col",
                    [
                      _c("v-switch", {
                        staticClass: "mt-0",
                        attrs: {
                          label: _vm.consoProd
                            ? _vm.generateMessage(
                                "properties_360.readings.combustible"
                              )
                            : _vm.generateMessage(
                                "properties_360.readings.vente"
                              ),
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.consoProd,
                          callback: function($$v) {
                            _vm.consoProd = $$v
                          },
                          expression: "consoProd"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.generateMessage("properties_360.readings.text")
                    },
                    model: {
                      value: _vm.tExt,
                      callback: function($$v) {
                        _vm.tExt = $$v
                      },
                      expression: "tExt"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _vm.formulas && _vm.formulas[0]
                ? _c("v-simple-table", {
                    staticClass: "elevation-2 secondarybackground",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.generateMessage(
                                            "properties_360.readings.annee"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.generateMessage(
                                            "properties_360.readings.r2"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.generateMessage(
                                            "properties_360.readings.pmoyen"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.formulas, function(item) {
                                  return _c("tr", { key: item.annee }, [
                                    _c("td", [_vm._v(_vm._s(item.annee))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.r2))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          (
                                            (item.a * _vm.tExt + item.b) *
                                            1000
                                          ).toFixed()
                                        )
                                      )
                                    ])
                                  ])
                                }),
                                0
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      4158067469
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.formulas && _vm.formulas[0]
                ? _c("v-simple-table", {
                    staticClass: "elevation-2 mt-2 secondarybackground",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    { staticClass: "text-left" },
                                    [
                                      _c("v-select", {
                                        staticClass: "text-caption pa-0",
                                        attrs: {
                                          items: _vm.boilerListOrigins,
                                          "hide-details": "",
                                          "single-line": ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item",
                                              fn: function({ item }) {
                                                return [
                                                  !item.empty
                                                    ? _c("span", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(item.text)
                                                          )
                                                        ])
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.text)
                                                        )
                                                      ])
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3656906753
                                        ),
                                        model: {
                                          value: _vm.boilerListOrigin,
                                          callback: function($$v) {
                                            _vm.boilerListOrigin = $$v
                                          },
                                          expression: "boilerListOrigin"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.generateMessage(
                                            "properties_360.readings.total"
                                          )
                                        ) +
                                        " :\n                " +
                                        _vm._s(
                                          _vm.totalPower -
                                            Math.trunc(_vm.totalPower) !==
                                            0
                                            ? _vm.totalPower.toFixed(1)
                                            : _vm.totalPower
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "text-left" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.generateMessage(
                                            "properties_360.readings.unit"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            "x-small": "",
                                            color: _vm.showColor("success")
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addBoiler()
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.generateMessage(
                                                    "properties_360.readings.icons.add"
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            "x-small": "",
                                            color: _vm.showColor("error")
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeAllBoilers()
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.generateMessage(
                                                    "properties_360.readings.icons.remove"
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.power, function(item, index) {
                                  return _c(
                                    "tr",
                                    {
                                      key: index,
                                      style: { cursor: "grab" },
                                      attrs: { draggable: "true" },
                                      on: {
                                        drop: function($event) {
                                          return _vm.drop_handler($event, index)
                                        },
                                        dragover: function($event) {
                                          return _vm.dragover_handler($event)
                                        },
                                        dragstart: function($event) {
                                          return _vm.dragstart_handler(
                                            $event,
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "td",
                                        [
                                          item.comment
                                            ? _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function({ on }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g(
                                                                {
                                                                  style: {
                                                                    border: `dashed ${_vm.powerColor(
                                                                      index,
                                                                      item.disabled
                                                                    )}`
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      item.name
                                                                    ) +
                                                                    "\n                    "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.comment))
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  style: {
                                                    border: `dashed ${_vm.powerColor(
                                                      index,
                                                      item.disabled
                                                    )}`
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(item.name) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Puissance",
                                              id: `puissance${index}`,
                                              type: "number"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.cumulatePower()
                                              },
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.selectNext(index)
                                              },
                                              focus: function($event) {
                                                return _vm.selectText(index)
                                              }
                                            },
                                            model: {
                                              value: _vm.power[index].value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.power[index],
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression: "power[index].value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.unit || "kW") +
                                            "\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                                color: _vm.showColor("grey")
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.enableDisableBoiler(
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              item.disabled
                                                ? _c("v-icon", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.generateMessage(
                                                            "properties_360.readings.icons.disabled"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                : _c("v-icon", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.generateMessage(
                                                            "properties_360.readings.icons.enabled"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                                color: _vm.showColor("error")
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeBoiler(index)
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.generateMessage(
                                                        "properties_360.readings.icons.remove"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2275526338
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }